<div class="expandable-panel">
    <div class="header row row-no-gutters">
        <div class="header-content" (click)="togglePanel()">
            <h1><ng-content select="[header]"></ng-content></h1>
            <span class="header-icon vismaicon vismaicon-arrow-right-circle" [ngClass]="{ expanded: expanded }"></span>
        </div>
    </div>

    <div class="body" [ngClass]="{ expanded: expanded }" [@collapse]="!expanded">
        <ng-content select="[body]"></ng-content>
    </div>
</div>
